import React, { useState, useEffect } from 'react';
import '../../components/Navbar/Navbar.css';
import { RiAccountCircleLine } from "react-icons/ri";
import { IoSearch } from "react-icons/io5";
import '../../styles/CustomClassCss/Custom.css';
import { getAuthToken } from "../../utils/auth";
import { Link, useNavigate } from "react-router-dom";
import { searchCategories } from '../../API/Api';

const Navbar = ({ toggleModal, isSidebarOpen }) => {
	const [token, setToken] = useState(null);
	const [searchQuery, setSearchQuery] = useState('');
	const navigate = useNavigate();

	useEffect(() => {
		setToken(getAuthToken());
	}, []);

	const handleSearch = async (e) => {
		e.preventDefault();

		try {
			const result = await searchCategories(searchQuery.trim());
			console.log("Search results:", result);
			navigate('/category-search', {
				state: { results: result, keyword: searchQuery }
			});
		} catch (err) {
			console.error("Search failed:", err);
		}
	};

	return (
		<nav className="navbar custom-container-side font-poppins">
			<div className="navbar-container">
				<div className="navbar-left">
					<span className="navbar-phone">
						<a href="tel:+917011588280" style={{ color: '#fff', textDecoration: 'none' }}>
							+91 7011588280
						</a>
					</span>

					<span className="navbar-separator">|</span>
					<span className="navbar-language">English</span>
					<span className="navbar-separator"></span>
					<span className="navbar-country">India</span>
					<span className="navbar-separator"></span>

					<Link to="/warehouses" className="navbar-locations">Warehouses</Link>
					<span className="navbar-separator"></span>

					<Link to="/tpi" className="navbar-locations">TPI</Link>
					<span className="navbar-separator"></span>

					<Link to="/transportation" className="navbar-locations">Transportation</Link>
				</div>

				<div className="navbar-right">
					<form onSubmit={handleSearch} className="navbar-search-form">
						<input
							type="text"
							placeholder="Search..."
							value={searchQuery}
							onChange={(e) => setSearchQuery(e.target.value)}
							className="navbar-search-input font-poppins"
						/>
						<button type="submit" className="navbar-search-submit">
							<IoSearch />
						</button>
					</form>

					<Link to="/extended-warranty" className="navbar-warranty-btn font-poppins">
						Extended Warranty
					</Link>

					{!token && (
						<button className="navbar-login font-poppins" onClick={toggleModal}>
							<RiAccountCircleLine className="navbar-icon" />
							Login/Register
						</button>
					)}
				</div>
			</div>

			{isSidebarOpen && !token && (
				<div className="sidebar-login-register">
					<button className="navbar-login font-poppins" onClick={toggleModal}>
						<RiAccountCircleLine className="navbar-icon" />
						Login/Register
					</button>
				</div>
			)}
		</nav>
	);
};

export default Navbar;
